import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/service/auth.service';
import { Router } from '@angular/router';
import { DesignService } from 'src/app/service/design.service';
import { AttributeModel } from '../dynamic/model/attribute.model';
import { environment } from 'src/environments/environment';
import { ProcessSummaryModel } from 'src/app/model/process-summary.model';
import { SearchParamsModel } from 'src/app/model/search-params.model';
import { WorkflowGatewayService } from 'src/app/service/workflow-gateway.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import swal from 'sweetalert2';
import { NotificationSharedService } from 'src/app/service/notification-shared.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  menuItems: AttributeModel[] = []
  menuOpened: boolean = true;
  registerItems: AttributeModel[]
  urlEnv = ""
  processes: ProcessSummaryModel[] = []
  searchParams: SearchParamsModel = new SearchParamsModel();
  unsubscribe = new Subject<any>();
  totalPendingItems: number = 0

  constructor(
    private authService: AuthenticationService,
    private designService: DesignService,
    private workflowService: WorkflowGatewayService,
    private router: Router,
    private notificationService: NotificationSharedService) { }


  get existPending(): boolean {
    return this.totalPendingItems > 0
  }

  get isAdminUser(): boolean {
    return this.authService.hasRole("admin")
  }

  get hasPermitionToViewUsers(): boolean {
    return this.authService.hasRole("view-users")
  }

  ngOnInit() {
    this.menuItems = this.designService.getMainMenu()
    this.registerItems = this.designService.getNewRegisterMenuItems()

    this.loadProcesses();
    this.notificationService.getItemCount().subscribe(count => {
      this.totalPendingItems = count
    });
    this.SetUrlEnv();
  }

  private loadProcesses(pagina?: number, showLoading: boolean = true): any {
    let user = this.authService.getUser();

    if(!user) {
      return;
    }

    this.workflowService
      .getCount(1, {
        searchParams: {
          currentStepUserId: user.id
        }
      })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((countResult) => {
        this.totalPendingItems = countResult.totalItems;
      }, (error)=> this.handleHttpError(error))
  }

  private SetUrlEnv() {
    if (environment.name == "develop") {
      this.urlEnv = ".dev";
    }
    else if (environment.name == "sandbox") {
      this.urlEnv = ".sandbox";
    }
    else {
      this.urlEnv = "";
    }
  }

  getItemRoute(routerItem: AttributeModel): string[] {
    if (routerItem.type.toLowerCase() == "newregister") {
      return [ 
        routerItem.value != null ? 
          this.getFormatedRoute(routerItem) : "/processes/typeProcess"
      ]
    } else {
      return [
        this.getFormatedRoute(routerItem)
      ];
    }
  }

  private getFormatedRoute(routerItem: AttributeModel): string {
    return (routerItem.value.startsWith("/"))
      ? routerItem.value : `/${routerItem.value}`;
  }

  getQueryParams(routerItem: AttributeModel) {
    let queryParams = routerItem.attributes.find(attr => 
      attr.type.toLowerCase() == "QueryParams".toLowerCase())

    if(queryParams) {
      let queryObj = {}

      queryParams.attributes.forEach(attr => {
        queryObj[attr.key] = attr.value
      })

      return queryObj
    }

    return {}
  }

  isExternal(item: AttributeModel): boolean {
    const v = (item && item.value ? item.value : '').toLowerCase()
    return v.startsWith('http://') || v.startsWith('https://') || v.startsWith('//') || v.startsWith('mailto:') || v.startsWith('tel:')
  }

  getLinkTarget(item: AttributeModel): string {
    const targetAttr = item && item.attributes ? item.attributes.find(a => (a.key || '').toLowerCase() === 'target') : null
    if (targetAttr && targetAttr.value) {
      const val = (targetAttr.value || '').toLowerCase()
      if (val === '_self' || val === '_blank' || val === '_parent' || val === '_top') {
        return val
      }
    }
    return '_blank'
  }

  private handleHttpError(error: any) {
    if(error.status == 401) {
      this.authService.logout()
      this.router.navigate(['login']);
    } else if(error.status == 403) {
      swal.fire("Atenção", "Este usuário não tem permissão para acessar este conteúdo.")
        .then(() => this.router.navigate([""]).then(() => swal.close()))
    } else if(error.message) {
      swal.fire("Atenção", error.message, "error").then(() => {
        if(error.goBackToHome) {
          this.router.navigate([""]).then(() => swal.close())
        }
      })
    } else {
      swal.fire("Atenção", "Algo errado aconteceu; Por favor, tente novamente.", "error")
    }
  }
}